import { http } from "@/http/http.js";
import { add } from "lodash-es";
import AddTask from "../../views/taskDispatch/addTask.vue";
export default {
  //校验当前登录账号身份
  getUserInfo (params) {
    return http.post("/common/queryAuthList", params);
  },
  //合同删除按钮
  contractDelete (params) {
    return http.post("/web/contractManage/cancelContractInfo", params);
  },
  //项目删除按钮
  projectDelete (params) {
    return http.post("/web/project/cancel", params);
  },
  //工单删除
  taskDelete (params) {
    return http.post("/web/workOrder/cancel", params);
  },
  //查询项目列表（已完成立项并通过审批）
  getProjectListPage (params) {
    return http.post("/web/task/listPage", params);
  },
  //查询项目详情
  getProjectDetail (params) {
    return http.post("/web/task/viewDetail", params);
  },
  //查询任务详情
  getTaskDetail (params) {
    return http.post("/web/task/viewTaskDetail", params);
  },
  //查询任务列表
  getTaskList (params) {
    return http.post("/web/task/viewTaskList", params);
  },
  //任务验收
  checkTask (params) {
    return http.post("/web/task/checkTask", params);
  },
  //查询工作项基础库信息
  queryAllWorkInfo (params) {
    return http.post("/web/workitem/queryAllWorkInfo", params);
  },
  //获取车辆
  listCar (params) {
    return http.post("/web/task/listCar", params);
  },
  //任务作业暂存
  addTaskItem (params) {
    return http.post("/web/task/addTaskItem", params);
  },
  //新增任务
  addTask (params) {
    return http.post("/web/task/addTask", params);
  },
  //任务修改
  updateTask (params) {
    return http.post("/web/task/editTask", params);
  },
  // 查询变更记录
  getChangeRecord (params) {
    return http.post("/web/task/getTaskChangeRecord", params);
  },
  // 新增作业项
  uploadTaskItem (params) {
    return http.post("/web/task/uploadTaskItem", params);
  }
};
